import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Router } from '@angular/router';
import { environment } from '@lib/environments/environment';
import { Licence } from '@lib/shared/models/licence.model';
import { User } from '@lib/shared/models/user.model';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AppAccessGuard {
  constructor(
    private router: Router,
    private afAuth: AngularFireAuth,
    private afs: AngularFirestore,
  ) {}

  async canActivate(): Promise<boolean> {
    const auth = await this.afAuth.currentUser;
    if (!auth) {
      this.router.navigate(['/login']);
      return false;
    }

    const userDoc = this.afs.doc<User>(`users/${auth.uid}`);
    const user = await firstValueFrom(userDoc.valueChanges());

    if (!user) {
      this.router.navigate(['/login']);
      return false;
    }

    const licencePath = typeof user?.licence === 'string' ? user.licence : user?.licence?.path;

    if (!licencePath) {
      this.router.navigate(['/no-licence']);
      return false;
    }

    const licence = await firstValueFrom(this.afs.doc<Licence>(licencePath).valueChanges());

    const fieldName = environment.appType === 'pe' ? 'pePro' : 'outdoorPro';

    if (!licence) {
      this.router.navigate(['/no-licence']);
      return false;
    }

    const hasBaseAppAccess = !!licence[fieldName];
    const hasBoltOnAccess = Array.isArray(licence.boltOnIds) && licence.boltOnIds.length > 0;

    if (!hasBaseAppAccess && !hasBoltOnAccess) {
      this.router.navigate(['/no-licence']);
      return false;
    }

    return true;
  }
}
